import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import SimpleMainPage from './pages/SimpleMainPage';
import AnnotatePage from './pages/AnnotatePage';
import RatePage from './pages/RatePage';
import QualifyPage from './pages/QualifyPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/generate" element={<SimpleMainPage />} />
      <Route path="/annotate" element={<AnnotatePage />} />
      <Route path="/rate" element={<RatePage />} />
      <Route path="/qualify" element={<QualifyPage />} />
    </Routes>
  );
}

export default App;
